import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { OnHoldProductsInputOnHoldTypeEnum } from 'api-client/src/server-api';

@Component({
  selector: 'on-hold-popup',
  templateUrl: './onHoldPopup.html',
  styleUrls: ['./onHoldPopup.scss'],
  standalone: false,
})
export class OnHoldPopupComponent {
  tickets: Array<any>;
  selectedTicketId: string = null;
  numberOfDays: number = null;

  constructor(public dialogRef: MatDialogRef<OnHoldPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.tickets = data.tickets;
  }

  hideModal(): void {
    this.dialogRef.close();
  }

  save(): void {
    this.dialogRef.close({
      ticketId: this.selectedTicketId,
      numberOfDays: this.numberOfDays,
    });
  }

  protected readonly OnHoldProductsInputOnHoldTypeEnum = OnHoldProductsInputOnHoldTypeEnum;
}
